import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getCollectionById({ commit }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/collections/${id}`,
        method: "GET",
      });
      commit(MutationsType.SET_COLLECTION, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllCollections({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/collections",
        method: "GET",
      });
      commit(MutationsType.SET_COLLECTIONS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveCollection({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/collections",
        method: "POST",
        data: payload,
      });
      commit(MutationsType.ADD_COLLECTION, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateCollection({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/collections/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_COLLECTION, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async deleteCollection({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/ecommerce/collections/${id}`,
        method: "DELETE",
      });
      commit(MutationsType.DELETE_COLLECTION, { id });
    } catch (error) {
      throw error.response.data;
    }
  },
  resetCollection({ commit }) {
    commit(MutationsType.SET_COLLECTION, null);
  },
  resetModuleCatalogCollection({ commit }) {
    commit(MutationsType.SET_COLLECTION, null);
    commit(MutationsType.SET_COLLECTIONS, null);
  },
};
